// extracted by mini-css-extract-plugin
export default {"wrapper":"fn-z","response":"gn-z","error":"hn-z","disabled":"in-z","buttons":"jn-z","feedbackQuestionSection":"kn-z","yesNoWrapper":"ln-z"};